/**
 * Store URLs für die App-Updates
 * 
 * WICHTIG: Diese URLs müssen mit den tatsächlichen Store-Links aktualisiert werden,
 * sobald die App in den Stores veröffentlicht ist.
 */

export const STORE_URLS = {
    // Android Play Store
    android: 'https://play.google.com/store/apps/details?id=com.csdresden.teampilot',
    
    // iOS App Store - Ersetzen Sie 1234567890 mit der tatsächlichen App Store ID
    ios: 'https://apps.apple.com/de/app/id1234567890'
};

/**
 * App Store Konfiguration
 */
export const STORE_CONFIG = {
    // Automatische Update-Prüfung beim App-Start aktivieren
    autoCheckOnStart: true,
    
    // Intervall für automatische Update-Prüfungen (in Millisekunden)
    // 24 Stunden = 24 * 60 * 60 * 1000
    checkInterval: 24 * 60 * 60 * 1000,
    
    // Minimale Zeit zwischen Update-Dialogen (in Millisekunden)
    // 1 Stunde = 60 * 60 * 1000
    minDialogInterval: 60 * 60 * 1000,
    
    // Anzahl der Tage, nach denen ein Update als "kritisch" betrachtet wird
    criticalUpdateDays: 7
};

/**
 * LocalStorage Keys für Update-Einstellungen
 */
export const UPDATE_STORAGE_KEYS = {
    lastUpdateCheck: 'app_update_last_check',
    lastDialogShown: 'app_update_last_dialog',
    dismissedVersion: 'app_update_dismissed_version'
};
